import {observer} from 'mobx-react';
import React, {useContext, useRef} from 'react';
import ReactSelect from '../../../components/react-select';
import useStore from '../../../hooks/use-store';
import {ButtomStyled} from '../../../styles';
import {useCompany} from '../../../providers/company';
import {useIntl} from 'react-intl';
import {ModalContext} from '../../../apiContexts';
import {trigger} from 'src/helpers/events';
import {getSnapshot} from 'mobx-state-tree';

const NewSinisterModal = () => {
    const openSinisterData = useRef(null);
    const {theme} = useCompany();
    const intl = useIntl();
    const {store} = useStore();
    const {devices: devicesStore, sinisterStore, session} = store;
    const {toggle} = useContext(ModalContext);

    const onSelectDevice = (option) => {
        const device = devicesStore.findById(option.id);
        if (!device) return;

        const deviceCustomer = device.getCustomer();

        const deviceSnapshot = getSnapshot(device);
        const deviceCurrentPositionSnapshot = device.currentPosition ? getSnapshot(device.currentPosition) : {};
        const deviceCustomerSnapshot = deviceCustomer ? getSnapshot(deviceCustomer) : {};

        openSinisterData.current = {
            deviceSnapshot,
            deviceCurrentPositionSnapshot,
            deviceCustomerSnapshot,
        };
    };

    const openSinister = () => {
        trigger('openSinister:click');
        sinisterStore.newSinister(
            openSinisterData.current.deviceCurrentPositionSnapshot,
            openSinisterData.current.deviceSnapshot,
            openSinisterData.current.deviceCustomerSnapshot,
            session,
        );
    };

    const onConfirmSinisterCreation = () => {
        openSinister();
        toggle();
    };

    return (
        <div>
            <ReactSelect
                scoped={false}
                id='deviceId'
                name='deviceId'
                options={devicesStore.listWithoutOpenSinisterAsOptions}
                onChange={onSelectDevice}
                noOptionsMessage={() => intl.formatMessage({id: 'sharedNoResultsFound'})}
                placeholder={intl.formatMessage({id: 'sharedChooseADevice'})}
            />

            <div aria-hidden className='my-3' />

            <div className='d-flex justify-content-end'>
                <ButtomStyled
                    onClick={onConfirmSinisterCreation}
                    theme={theme}
                    className="custom-shadow custom-border btn-theme"
                    outline
                    type="button">
                        {intl.formatMessage({id: 'sinisterCreate'})}
                </ButtomStyled>
            </div>
        </div>
    );
};

export default observer(NewSinisterModal);
